module.exports = __webpack_public_path__ + "static/img/logo-aula-virtual.1ab01c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-aula-virtual.png
// module id = rEgT
// module chunks = 9